import React from 'react'
import { useTranslation } from 'react-i18next'
import { WarningDialogWindow } from 'src/editor/shared/ui-lib/modal-window/dialog-window/warning-dialog-window'
import { setWebsitePagesQueryDataArgs } from 'src/editor/api/hooks/use-query-website-pages'
import { useMutationWithValidation } from 'src/editor/api/hooks/use-api-mutation-with-validation'
import { unpublishWebsitePage } from 'src/editor/api/website-pages-api'

export interface UnpublishPageModalProps {
  websiteId: number
  websitePageSetId: number
  websitePageId: number
  isOpened: boolean
  onClose: () => void
}

export const UnpublishPageModal = ({
  websiteId,
  websitePageSetId,
  websitePageId,
  isOpened,
  onClose,
}: UnpublishPageModalProps) => {
  const { t } = useTranslation()

  const { fetcher, isLoading } = useMutationWithValidation({
    requestFunction: unpublishWebsitePage,
    successToastMessage: t(
      'website_settings.sidebar.pages_management.unpublish_page.unpublished_successfully',
    ),
    handleFinally: onClose,
    setQueryDataArgsOnSuccess: setWebsitePagesQueryDataArgs(
      websiteId,
      prevData => ({
        ...prevData,
        pages: prevData.pages.map(websitePageSet =>
          websitePageSet.id === websitePageSetId
            ? {
                ...websitePageSet,
                locales: websitePageSet.locales.map(websitePage =>
                  websitePage.id === websitePageId
                    ? { ...websitePage, active: false }
                    : websitePage,
                ),
              }
            : websitePageSet,
        ),
      }),
    ),
  })

  const handleUnpublishPage = () => {
    if (websitePageId) {
      fetcher({ websitePageId })
    }
  }

  return (
    <WarningDialogWindow
      isOpened={isOpened}
      onClose={onClose}
      title={t(
        'website_settings.sidebar.pages_management.unpublish_page.title',
      )}
      description={t(
        'website_settings.sidebar.pages_management.unpublish_page.description',
      )}
      cancelButtonProps={{
        children: t('global.cancel'),
        onClick: onClose,
      }}
      confirmButtonProps={{
        isLoading,
        onClick: handleUnpublishPage,
        children: t(
          'website_settings.sidebar.pages_management.unpublish_page.unpublish_button',
        ),
      }}
    />
  )
}
